import { NavLink } from 'react-router-dom';

const TABS = [
  { to: '/', label: 'Collect', icon: '🚗', end: true },
  { to: '/trips', label: 'Trips', icon: '🛣️', end: false },
  { to: '/settings', label: 'Settings', icon: '⚙️', end: false },
];

/** Bottom-anchored so every primary action stays within thumb reach. */
export function Nav() {
  return (
    <nav className="nav">
      <div className="nav-inner">
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) => (isActive ? 'active' : undefined)}
          >
            <span className="nav-icon" aria-hidden="true">{tab.icon}</span>
            <span>{tab.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
